import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MarketplaceIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Marketplace",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.38 16.19c-1.06-.19-1.92-.96-2.31-1.92 0-.1-.1-.1-.19-.1l-.1.1c-.48 1.25-1.73 2.02-2.98 2.02-1.63 0-3.27-.87-3.65-2.02 0-.1-.19-.19-.29 0-.58 1.25-1.92 2.02-3.27 2.02-1.44.1-2.79-.67-3.56-2.02 0-.1-.19-.1-.19 0-.87 1.35-1.35 2.02-3.08 2.02-.38 0-.77 0-1.15-.19v12.6h22.02V16.2c-.38.1-.77.1-1.25 0Zm-9.42 3.27c0-.38.29-.67.67-.67h6.92c.38 0 .67.29.67.67v4.04c0 .38-.29.67-.67.67h-6.92c-.38 0-.67-.29-.67-.67zM7.5 27.83v-7.21c0-.38.29-.67.67-.67h3.65c.38 0 .67.29.67.67v7.31h-5v-.1ZM9.23 3.31l-1.06 9.23c-.29 1.44-1.63 2.5-3.08 2.31-1.73 0-3.27-1.06-3.08-2.31s2.6-9.23 2.6-9.23zm6.44 0v9.23c0 1.35-1.35 2.31-3.08 2.31s-3.08-1.06-3.08-2.31c.1-1.63.77-9.23.77-9.23zm.96 0v9.23c0 1.35 1.35 2.31 3.08 2.31s3.08-1.06 3.08-2.31l-.77-9.23zm6.25 0 .96 9.23c0 1.35 1.35 2.31 3.08 2.31S30 13.79 30 12.54l-2.5-9.23z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M26 14.43c-1.36 0-2.59-.6-3.43-1.55-.84.95-2.07 1.55-3.43 1.55s-2.59-.6-3.43-1.55c-.84.95-2.06 1.55-3.43 1.55s-2.59-.6-3.43-1.55c-.84.95-2.07 1.55-3.43 1.55-2.52 0-4.57-2.05-4.57-4.57 0-.1.01-.2.04-.3L2.73 2.7c.13-.5.59-.85 1.1-.85h23.75c.52 0 .97.35 1.11.85l1.84 6.86c.03.1.04.2.04.3 0 2.52-2.05 4.57-4.57 4.57m-2.28-4.57c0 1.26 1.03 2.29 2.29 2.29s2.21-.95 2.28-2.15l-1.57-5.85H4.71L3.14 10c.07 1.2 1.07 2.15 2.28 2.15s2.29-1.03 2.29-2.29a1.14 1.14 0 1 1 2.28 0c0 1.26 1.03 2.29 2.29 2.29s2.29-1.03 2.29-2.29a1.14 1.14 0 1 1 2.28 0c0 1.26 1.03 2.29 2.29 2.29s2.29-1.03 2.29-2.29a1.14 1.14 0 1 1 2.28 0Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.29 29.28h-5.71c-.63 0-1.14-.51-1.14-1.14v-8h-4.57v8c0 .63-.51 1.14-1.14 1.14H3.15c-.63 0-1.14-.51-1.14-1.14V17.86a1.14 1.14 0 1 1 2.28 0V27h10.29v-8c0-.63.51-1.14 1.14-1.14h6.86c.63 0 1.14.51 1.14 1.14v8h3.43V12.41a1.14 1.14 0 1 1 2.28 0v15.73c0 .63-.51 1.14-1.14 1.14"
      })]
    })
  }));
};
MarketplaceIcon.displayName = 'MarketplaceIcon';